export const fmtTL = (n) => {
  const v = Number(n || 0);
  return "₺" + v.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("tr-TR");
  } catch { return d; }
};

export const fmtDateTime = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });
  } catch { return d; }
};

export const todayISO = () => new Date().toISOString();
